<template>
  <div class="container">
    <div class="wrapper box-shadow">
        <div class="row align-items-center img-panel">
            <div class="col text-center my-3">
                <loading color="#00a088" :isFullScreen="false"></loading>
            </div>
        </div>
        <div class="row icon-panel">
          <div class="col text-center">
            {{$t("share.status.tip")}}
          </div>
        </div> 
    </div>
  </div>
</template>

<script>
import Loading from '../components/Loading'
import {checkStatusFromClient} from '../services/api.js'
export default {
  name: 'ShareStatus',
  components: {
    Loading
  },
  data() {
    return {
      ip: '',
      port: '',
      shareID: ''
    }
  },
  methods:{
    alertMessage(message) {
      this.$toasted.error(message, null, {
        timeOut: 0, 
        hideDuration: 0, 
        extendedTimeOut: 0, 
        closeButton: true
        })
    },
    checkStatus(ip, port, shareId) {
      let url = 'http://' + ip + ':' + port + '/check' + '?share_id=' + shareId
      checkStatusFromClient(url)
        .then(response => {
          let status = response.data.status
          switch(status) {
            case 1: {
              //waiting
              setTimeout(() => {
                this.checkStatus(ip, port, shareId)
              }, 5000)
              break;
            }
            case 2: {
              //success
              let redirectUrl = response.data.url
              window.location.href = redirectUrl 
              break;
            }
            case 3: {
              //error
              this.alertMessage('Share failed, please try again from Screen Capture.')
              break;
            }
            default: {
              this.alertMessage('Unkonw status: ' + status)
              break;
            }
          }
        })
        .catch(error => {
          this.alertMessage(error)
        })
    }
  },
  created() {
    this.ip = this.$route.query.ip
    this.port = this.$route.query.port
    this.shareID = this.$route.query.share_id
    if(!this.ip || !this.port || !this.shareID) {
      this.alertMessage("Params missing...")
      return
    }
    setTimeout(() => {
      this.checkStatus(this.ip, this.port, this.shareID)
    }, 5000)
  }
}
</script>

